import React from 'react';
import { motion } from 'framer-motion';

// Real app screenshot URLs
const SCREENSHOTS = {
  home: "https://customer-assets.emergentagent.com/job_marketing-economy/artifacts/1xllpeiw_34BAC07C-EA81-489F-BFBA-BE63004BC563.jpg",
  missions: "https://customer-assets.emergentagent.com/job_marketing-economy/artifacts/y12yedsl_34BAC07C-EA81-489F-BFBA-BE63004BC563%202.jpg",
  wallet: "https://customer-assets.emergentagent.com/job_marketing-economy/artifacts/zw7gplzr_34BAC07C-EA81-489F-BFBA-BE63004BC563%203.jpg",
  marketplace: "https://customer-assets.emergentagent.com/job_marketing-economy/artifacts/7tuw4i7m_34BAC07C-EA81-489F-BFBA-BE63004BC563%204.jpg"
};

// Phone Frame Component - can accept screenshot URL or children
export const PhoneFrame = ({ screenshot, className = '', children }) => (
  <div className={`relative ${className}`}>
    <div className="bg-gradient-to-b from-[#2a2a3a] to-[#1a1a2a] rounded-[2.5rem] p-1.5 shadow-2xl shadow-black/30">
      <div className="bg-white rounded-[2.2rem] overflow-hidden relative">
        {screenshot ? (
          <img 
            src={screenshot} 
            alt="AQERA App" 
            className="w-full h-auto"
            style={{ aspectRatio: '390/844' }}
          />
        ) : children}
      </div>
    </div>
  </div>
);

// Individual screen mockup images (without phone frame) - for use inside PhoneFrame
export const HomeScreenMockup = () => (
  <img 
    src={SCREENSHOTS.home} 
    alt="AQERA Home" 
    className="w-full h-auto"
    style={{ aspectRatio: '390/844' }}
  />
);

export const MissionsScreenMockup = () => (
  <img 
    src={SCREENSHOTS.missions} 
    alt="AQERA Missions" 
    className="w-full h-auto"
    style={{ aspectRatio: '390/844' }}
  />
);

export const WalletScreenMockup = () => (
  <img 
    src={SCREENSHOTS.wallet} 
    alt="AQERA Wallet" 
    className="w-full h-auto"
    style={{ aspectRatio: '390/844' }}
  />
);

export const MarketplaceScreenMockup = () => (
  <img 
    src={SCREENSHOTS.marketplace} 
    alt="AQERA Marketplace" 
    className="w-full h-auto"
    style={{ aspectRatio: '390/844' }}
  />
);

// Combined Hero Mockup with real app screenshots
export const HeroMockup = () => (
  <div className="relative w-full max-w-[700px] mx-auto">
    {/* Main Phone - Home */}
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="relative z-30"
    >
      <PhoneFrame screenshot={SCREENSHOTS.home} className="w-[220px] mx-auto" />
    </motion.div>
    
    {/* Left Phone - Wallet */}
    <motion.div
      initial={{ opacity: 0, x: -60 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8, delay: 0.4 }}
      className="absolute left-0 top-12 z-20 hidden lg:block"
    >
      <PhoneFrame screenshot={SCREENSHOTS.wallet} className="w-[190px]" />
    </motion.div>
    
    {/* Right Phone - Missions */}
    <motion.div
      initial={{ opacity: 0, x: 60 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8, delay: 0.6 }}
      className="absolute right-0 top-12 z-20 hidden lg:block"
    >
      <PhoneFrame screenshot={SCREENSHOTS.missions} className="w-[190px]" />
    </motion.div>
    
    {/* Subtle shadow */}
    <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[400px] h-[80px] bg-gradient-to-t from-black/10 to-transparent blur-2xl -z-10 rounded-full" />
  </div>
);

export default HeroMockup;
